module.exports = __webpack_public_path__ + "media/images/badge/stratega-bdfe7ca865711de944af6a6684375787.png";